import React, { useState, useEffect } from "react";

import QRCode from "react-qr-code";

import { Paper } from "@material-ui/core";
import { Container, ImgFooter, ImgHeader, ImgWifi } from "./styles";
import { useDataProvider } from "react-admin";
import { useReactToPrint } from "react-to-print";

const Item = (props) => {
  return (
    <Container {...props} bg={require("../Assets/images/borda_template.png")}>
      <ImgHeader src={require("../Assets/images/topo_template.png")} />
      <p className="pageTitle">
        para visualizar o nosso
        <br /> menu acesse o link :<br />
      </p>
      <p>
        <strong>
          <a href={`${window.location.protocol}//${window.location.host}`}>
            {`${window.location.host}`}
          </a>
        </strong>
      </p>
      <p>
        Ou utilize o QRCode abaixo <br /> com o seu smartphone
      </p>
      <QRCode
        value={`${window.location.protocol}//${window.location.host}?qrcode_origin=default`}
        size={100}
      />

      <p>
        {props?.data?.wifi && (
          <>
            <ImgWifi src={require("../Assets/images/wifi.png")} />
            <br />
            Wifi: <strong>{props?.data?.wifi}</strong>
            <br />
            {props?.data?.wifiPassword && (
              <>
                Senha: <strong>{props?.data?.wifiPassword}</strong>
              </>
            )}
          </>
        )}
      </p>
    </Container>
  );
};

export class ComponentToPrint extends React.Component {
  render() {
    return (
      <table style={{ marginLeft: 20, marginTop: 15 }}>
        <tbody>
          <tr>
            <td>
              <Item data={this.props.data} />
            </td>
            <td>
              <Item data={this.props.data} />
            </td>
          </tr>
          <tr>
            <td>
              <Item data={this.props.data} />
            </td>
            <td>
              <Item data={this.props.data} />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
